import React, { useEffect, useState } from 'react';
import './privilageStyles.css';
import { ErrorToast, SuccessToast } from '../../../utils/toast';
import {  get_roles_with_pagination } from '../../../config/SettingsApis/rolesApis';
import { get_privilages, get_privilages_list, update_role_privilages } from '../../../config/GeneralApis/privilegeApis';
import CustomSelectDropdown from '../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { useFormik } from 'formik';
import ActionButton from '../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { setPrivileges } from '../../../features/privileges/privilegesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { hasPrivilege } from '../../../utils/privileges';
import CustomBreadcrumbs from '../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import TextSkeleton from '../../../Components/Skeletons/TextSkeleton';

function Permissions() {
  const privileges = useSelector((state) => state.privileges.privileges);
  const dispatch = useDispatch();

  const [modulesPrivilages, setModulePrivilages] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      role: '',
    },
    onSubmit: (values) => {
      handleSave(values)
    },
  });

  // FETCH Roles
  const fetchRoles = async () => {
    try {

      const response = await get_roles_with_pagination({ status: 1 });
      if (response?.status === "success") {
        // Transform data into the desired format with label and value
        const transformedData = response.data.data?.map((item) => ({
          label: item?.Rolename,
          value: item?.RoleID
        })).filter(role => role.value !== 5); // Remove role ID 5 , value 5 === ENGINEER;
        // Set the transformed data to the state
        setRolesList(transformedData || []);
        formik.setFieldValue("role", (transformedData[0]?.value)) //set intially the first positions of the roles list array
      } else {
        setRolesList([]);
      }
    } catch (error) {
      console.error('Error fetching :', error);
      setRolesList([]);
    }
  };

  // FETCH Privileges
  const fetchPrivileges = async (data) => {
    try {
      const response = await get_privilages_list(data);

      if (response?.status === "success") {
        let privilagearray = []
        privilagearray = response?.data?.map((module) => ({
          ...module,
          submodules: module.submodules.map((submodule) => ({
            ...submodule,
            privileges: submodule.privileges,
          })),
        }))
        setModulePrivilages(privilagearray)
      } else {
        setModulePrivilages([]);
      }
    } catch (error) {
      console.error('Error fetching :', error);
      setModulePrivilages([]);
    }
  };

  // FETCH ROLES LIST
  useEffect(() => {
    fetchRoles()
  }, [])

  // FETCH PRIVILEGES BY ROLE ID
  useEffect(() => {
    if (formik.values.role) {
      const params = {
        role_id: formik.values.role
      }
      fetchPrivileges(params)
    }
  }, [formik.values.role, refresh]);

  // CHECKBOX CHECK AND UNCHECK
  const handlePrivilegeChange = (moduleIndex, submoduleIndex, privilegeIndex) => {
    const updatedModules = [...modulesPrivilages];
    const currentPrivilege = updatedModules[moduleIndex].submodules[submoduleIndex].privileges[privilegeIndex];
    currentPrivilege.checked = currentPrivilege.checked === 0 ? 1 : 0;
    setModulePrivilages(updatedModules);
  };
  // SELECT ALL BUTTON CLICK

  const handleSubmoduleSelectAll = (moduleIndex, submoduleIndex) => {
    const updatedModules = [...modulesPrivilages];
    const submodule = updatedModules[moduleIndex].submodules[submoduleIndex];
    const allSelected = submodule.privileges.every((privilege) => privilege.checked === 1);

    submodule.privileges.forEach((privilege) => {
      privilege.checked = allSelected ? 0 : 1;
    });

    setModulePrivilages(updatedModules);
  };



  // Function to get Privileges for save
  const getSubmodulePrivileges = (modules) => {
    return modules.flatMap(module =>
      module.submodules.map(submodule => ({
        submodule_id: submodule.submodule_id,
        privileges_id: submodule.privileges
          .filter(privilege => privilege.checked === 1)
          .map(privilege => privilege.id)
      }))
    );
  };

  // FOR SAVE 
  const handleSave = async (datas) => {
    const Privileges = getSubmodulePrivileges(modulesPrivilages);
    try {
      setIsButtonDisabled(true)
      const payload = {
        role_id: datas.role,
        privileges: JSON.stringify(Privileges),
      }
      const response = await update_role_privilages(payload)
      if (response?.status === "success") {
        SuccessToast(response?.message)
        setRefresh(!refresh)

      } else {
        ErrorToast(response?.message || `Something went wrong`)
      }
    } catch (error) {
      console.log("error", error);

    } finally {
      setIsButtonDisabled(false)
    }

  };


  useEffect(() => {
    const fetchPrivileges = async () => {
      setIsLoading(true)
      try {
        const permissionResponse = await get_privilages(); //GET PRIVILEGES DETAILS
        dispatch(setPrivileges(permissionResponse));
      } catch (error) {
        console.error("Error fetching privileges:", error);
      } finally {
        setIsLoading(false)
      }
    };
    fetchPrivileges();
  }, [refresh]);


  // Define the required permission actions
  const PERMISSION_ACTIONS = {
    view: 4,
    edit: 5,
    history: 6,
    add: 3,
  };

  // Map permissions to boolean values based on privileges
  const userPermissions = {
    view: hasPrivilege(privileges, "Settings", 15, PERMISSION_ACTIONS.view),
    edit: hasPrivilege(privileges, "Settings", 15, PERMISSION_ACTIONS.edit),
    history: hasPrivilege(privileges, "Settings", 15, PERMISSION_ACTIONS.history),
    add: hasPrivilege(privileges, "Settings", 15, PERMISSION_ACTIONS.add),
  };

  const breadcrumbs = ['Settings', 'Privileges']

  return (

    <div className='privilages_module_main_container'>
      <div className='lookup-filter-container'>
        <div className='lookup-filter-sub-container'>
          <div className='technology-lookup-search-left'>
            <div className="lookup-section-title">{isLoading ? <TextSkeleton width='100%' fontSize='3rem' /> : `Privileges`}</div>
            {isLoading ? (
              <div className="breadcrumbs-skeleton-container">
                <TextSkeleton width="100%" fontSize="2rem" />
                <TextSkeleton width="100%" fontSize="2rem" />
              </div>
            ) : (
              <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div></div>
            <div className='lookup-action-button-container'>
              {isLoading ? <div className="save-button-skeleton">
                <TextSkeleton width="100%" fontSize="3rem" />
              </div> : userPermissions?.add && <ActionButton onClick={() => formik.handleSubmit()} btnDisable={isButtonDisabled} label="Save" btnType="primary" />}
            </div>
          </div>
        </div>
      </div>

      <div className='privilages_module_sub_container_2'>
        {isLoading ? <TextSkeleton width='5%' fontSize='1rem' /> : <div className="label-container">
          <span className="label">Role <span className="label_required_remark">*</span></span>
        </div>}

        {isLoading ? (
          <TextSkeleton width='15%' fontSize='3rem' />
        ) : (
          <div className='role-select-container'>
            <CustomSelectDropdown
              name="role"
              placeholder="Select a role"
              options={rolesList}
              value={rolesList?.find((option) => option?.value === formik?.values?.role) || ""}
              onChange={(selectedOption) => formik.setFieldValue("role", selectedOption ? selectedOption.value : "")}
              isClearable={false}
              width="100%"
            />
          </div>
        )}
      </div>
      <div className="privilage_module_wise_main_container">
        {isLoading
          ? Array(2)
            .fill(0)
            .map((_, moduleIndex) => (
              <div className="privilage_module_wise_container" key={moduleIndex}>
                {Array(2)
                  .fill(0)
                  .map((_, submoduleIndex) => (
                    <div className="privilage_module_wise_container" key={submoduleIndex}>

                      <div className="privilage_actions_container">
                        {Array(5)
                          .fill(0)
                          .map((_, privilegeIndex) => (
                            <div className="privilage_actions_sub_container" key={privilegeIndex}>
                              <div className="checkbox-skeleton" />
                              <TextSkeleton width="60%" fontSize="0.9rem" />
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}
              </div>
            ))
          :
          modulesPrivilages?.map((module, moduleIndex) => (
            <div className='privilage_module_wise_container' key={module.module_name}>
              <p className='privilage_sub_legend'><b>{module.module_name}</b></p>

              {module?.submodules.map((submodule, submoduleIndex) => (
                <div className='privilage_module_wise_container' key={submodule.submodule_id}>
                  <p className='privilage_sub_legend'><b>
                    <input
                      type="checkbox"
                      checked={submodule.privileges.every(privilege => privilege.checked === 1)}
                      onChange={() => handleSubmoduleSelectAll(moduleIndex, submoduleIndex)}
                    />{submodule.submodule_name}</b></p>

                  <div className='privilage_actions_container'>

                    {submodule.privileges.map((privilege, privilegeIndex) => (
                      <div className='privilage_actions_sub_container' key={privilege.id}>
                        <input
                          type="checkbox"
                          checked={privilege.checked === 1}
                          onChange={() => handlePrivilegeChange(moduleIndex, submoduleIndex, privilegeIndex)}
                        />
                        <span>{privilege.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
      </div>

    </div>
  );
}

export default Permissions;
